import ClusterCustomer from './ClusterCustomer'

export default ClusterCustomer
